"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapButtonAppearance = void 0;
const lodestarAppearances = new Set(["primary", "secondary", "destructive", "secondary-destructive", "borderless"]);
const mapButtonAppearance = (appearance, themeMode) => {
  let actualAppearance = appearance;
  if (themeMode === "ursa-light" && lodestarAppearances.has(actualAppearance)) {
    switch (actualAppearance) {
      case "primary":
        actualAppearance = "primary-filled";
        break;
      case "secondary":
        actualAppearance = "secondary-filled";
        break;
      case "destructive":
        actualAppearance = "destructive-filled";
        break;
      case "secondary-destructive":
        actualAppearance = "destructive-empty";
        break;
      case "borderless":
        actualAppearance = "primary-empty";
        break;
    }
  }
  return actualAppearance;
};
exports.mapButtonAppearance = mapButtonAppearance;
//# sourceMappingURL=mapButtonAppearance.js.map